var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FranchiseReportTable',{attrs:{"headers":_vm.headers,"load-report-url":"google-report","user-search":_vm.userSearch,"human-readable-report-name":"Google Report","excel-report-name":"google_report"}})}
var staticRenderFns = []

export { render, staticRenderFns }